import { render, staticRenderFns } from "./SalesOverview.vue?vue&type=template&id=4086e3fc"
import script from "./SalesOverview.vue?vue&type=script&lang=js"
export * from "./SalesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports